import React from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useBottomSheet } from "@danishagro/shared/src/contexts/bottomSheet/bottomSheet.context";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import S from "./DeleteUserBottomSheet.module.scss";

interface DeleteUserBottomSheetProps {
    id: string;
    name: string;
    onRemove: () => void;
}

export const _DeleteUserBottomSheet = (props: DeleteUserBottomSheetProps) => {
    const { getDictionaryString } = useTranslations();
    const { dismissBottomSheet } = useBottomSheet();

    // Set name prop as constant for use in getTextItem
    const name = props.name;

    return (
        <>
            <DA_Icon name={DA_IconNames.WarningSign} className={S.icon} />
            {getDictionaryString("deleteBottomSheetText", { name })}
            <div className={S.footerWrapper}>
                <div className={S.textWrapper}>
                    <DA_Text noPadding bold>
                        {getDictionaryString("confirmText")}
                    </DA_Text>
                </div>
                <div className={S.buttonWrapper}>
                    <DA_Button
                        title={getDictionaryString("confirm", {
                            uppercaseFirst: true,
                        })}
                        onClick={props.onRemove}
                        className={S.primary}
                    />
                    <DA_Button
                        isGhost
                        title={getDictionaryString("cancel")}
                        onClick={() => dismissBottomSheet()}
                        className={S.secondary}
                    />
                </div>
            </div>
        </>
    );
};
